import pkg from '../package.json';
import { normalize } from './normalize';
const version = pkg.version;
export { compile } from './compile/compile';
export { extractTransforms } from './transformextract';
export { normalize, version };
//# sourceMappingURL=index.js.map